var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_6431_6986)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6431_6986",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6431_6986",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6431_6986",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADr0lEQVR4nO3baahnYxwH8LkzBmMbso0xzGCGjK3JJGQZa7YkWbNGsmSJklJSSklJqUlKKElJ3vBKkiTxgkSiscxiHWM3M9wx5uPFuVfX9f+f53/HOec5587v8/re/+/7+z117nme+/ynTAkhhBBCCCGEEEIIIYQQQgghhBBCCCFskTAfT2JG7ixtgRkjM5lfd6F9sVzhNexQa8EOwHZ4eWQmX2D/ugrtg8/92+vYsZaCHTAy/FfGzWQl9qu60Bx8qrc3sFOlBTsA2+PVPjNZgblVFlvap9CoNzGzsoIth5kjPZdZWmXBrfFCouA72LWyoi2FnfFWYhYvYduqC0/H84nC72K3Sgu3CHbB24kZvIht6gowDU8nAnyIWbUEyAi7471E789het1BpuGpRJCPsFetQRqEPfB+oudnsVVTgabiiUSgj7F3I4FqhD3xQaLXZxob/phgQ9JvR8swp9FgFcIsxSO1zOOYmivgEB5JBFyu6o1JAxQbz08SvT2Wbfhjgg7h4UTQlTgga9AJwFz9N56jHsVQ7qz/wP2JwKvUfVhVAczz3yOX8R7KnbMn3JcI/g0W5s7ZDw5UHKiVeTB3zlK4K9HAtzg0d87xcBC+SmR/IHfOgQywCKtxWO6co3Awvk5kvjd3zgnBnYmGfsTiFuQ8At8lst6TO+dmwR3YVNLYTzgqY75FWJMY/t258lUCNyQW4WccnSHXkfihJNcm3NZ0rlrgOvyVWIRjGsyzWPEILBv+LU3laQSuTSzCWpzUQI7j8Eti+DfVnSMLXIo/S5pfh1NqrH88fi2pvxFX11W/FXDxAItwWg11T8RvieFfWXXdVsKF2FAyjD9wboX1zsD6xPAvr6peJ+CckUH3M4zzKqhzJn4vqbMB51fRU+fgrMRwhv/PcHB2E4vcaYrHQ9kibMRlm/G5Fyh/zA2r8DHXaViieA0tW4QrJvB5Fyn/Q78ep9fZU+fgBOm3lKsG+JxLEsNfh1Ob6KlzFJuksvf00k0SrpHe7J3cZE+dg2Old6o39/i91HHHWizJ0FL3GOyg7NYxP399YvhZDvw6TXFU/H1iEW7HjVp85N1pBjuvL7MGi3L30WkG+3dhL6txeO78kwIWKm5UDKrVty86SXFl5MsBh39I7ryTEhYoLnj1swoLcuec1BTXBj/rMfxOXX/sNMXXZcfe3Vyhrq+Hht4Ut5eXKe5xzsudZ4uE2ZidO0cIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCKFl/gaMZzSx3wyExgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrow-down-white.3e83b9ef71c2cc753144c1594fced122.svg";
export { ForwardRef as ReactComponent };